/**
 * Firebase Environment Configuration - Production
 * 
 * This file contains the Firebase configuration for the production environment.
 */

const environment = 'production';

const config = {
  apiKey: 'AIzaSyDJslvX-bKrdUsYyHn0Xf06odMu44JVWTg',
  authDomain: 'gantty-app.firebaseapp.com',
  projectId: 'gantty-app',
  storageBucket: 'gantty-app.firebasestorage.app',
  messagingSenderId: '495844398074',
  appId: '1:495844398074:web:bf11751adcf02abb008a43',
  measurementId: 'G-T34ELZFZ2Y',
};

// Cloud Function URLs
const execSummaryFunctionUrl = 'https://europe-west1-gantty-app.cloudfunctions.net/generateExecutiveSummary';
const changeSummaryFunctionUrl = 'https://europe-west1-gantty-app.cloudfunctions.net/generateChangeSummary';
const exportUserDataFunctionUrl = 'https://europe-west1-gantty-app.cloudfunctions.net/exportUserData';
const deleteUserWithErasureReportFunctionUrl = 'https://europe-west1-gantty-app.cloudfunctions.net/deleteUserWithErasureReport';
const chatbotFunctionUrl = 'https://europe-west1-gantty-app.cloudfunctions.net/chatbotDataset';
const holidaysFunctionUrl = 'https://europe-west1-gantty-app.cloudfunctions.net/holidaysApi';
const datasetAccessRequestFunctionUrl = 'https://europe-west1-gantty-app.cloudfunctions.net/datasetAccessRequest';

// Export for backward compatibility
export default {
  environment,
  config,
  execSummaryFunctionUrl,
  changeSummaryFunctionUrl,
  exportUserDataFunctionUrl,
  deleteUserWithErasureReportFunctionUrl,
  chatbotFunctionUrl,
  holidaysFunctionUrl,
  datasetAccessRequestFunctionUrl,
};

export { environment, config, execSummaryFunctionUrl, changeSummaryFunctionUrl, exportUserDataFunctionUrl, deleteUserWithErasureReportFunctionUrl, chatbotFunctionUrl, holidaysFunctionUrl, datasetAccessRequestFunctionUrl };
